import type { CatalogItem } from '../types/catalogItem';

export const getProductLicenseType = (code: string) => code[8];
export const getProductSubType = (code: string) => code[9];

const getLicenseTypeBySymbol = (s: string | undefined) => {
  switch (s) {
    case 'S':
      return 'Standard';
    case 'E':
      return 'Evaluation';
    case 'T':
      return 'Trial';
    case 'B':
    case 'L':
      return 'Beta';
    case 'P':
      return 'PLE';
    case 'C':
      return 'License Compliance';
    case 'M':
      return 'Temporary';
    default:
      return 'n/a';
  }
};

const getSubTypeBySymbol = (s: string | undefined) => {
  switch (s) {
    case 'C':
      return 'Commercial';
    case 'U':
      return 'University';
    case 'E':
      return 'EDU';
    case 'T':
      return 'Training';
    case 'A':
      return 'Additional university';
    case 'D':
      return 'Studio';
    case 'O':
      return 'Educator';
    case 'N':
      return 'Student';
    default:
      return 'n/a';
  }
};

export const getProductInfoByCode = (productCode: string) => {
  const licenseTypeSymbol = getProductLicenseType(productCode);
  const licenseType = getLicenseTypeBySymbol(licenseTypeSymbol);
  const subTypeSymbol = getProductSubType(productCode);
  const subType = getSubTypeBySymbol(subTypeSymbol);

  return { licenseType, subType };
};

/** The same checks the webshop's cart and GTM code use to spot a trial. */
export const isTrial = ({ category, productCode }: CatalogItem): boolean =>
  category === 'Free Product' ||
  getProductInfoByCode(productCode).licenseType === 'Trial';
